import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-leave-type',
  templateUrl: './add-leave-type.component.html'
})
export class AddLeaveTypeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/leave/components/add-leave-type/add-leave-type.component.ts